module.exports = __webpack_public_path__ + "b671f11f4f97a76bbb45cc281519b7e5.png";